export default __webpack_public_path__ + "static/media/orange.3536ca99.jpg";